import { securitiesStorageKey } from '../constants/localStorage';

export const getUserLoginStatus = (): boolean => {
  const tradeLoginStatus = localStorage.getItem(
    securitiesStorageKey.tradeIsLogin,
  );
  const accessToken = localStorage.getItem(securitiesStorageKey.accessToken);
  const targetAPI = localStorage.getItem(securitiesStorageKey.targetAPI);
  return Boolean(tradeLoginStatus && accessToken && targetAPI);
};
